import { memo, useState } from "react";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { cn } from "@/core/utils/utils";
import { IcmPieChart, IcmPieChartEntry } from "./icm-pie-chart";

export interface IcmPieTab {
  label: string;
  data: IcmPieChartEntry[];
}

interface IcmTabbedPieChartProps {
  tabs: IcmPieTab[];
  className?: string;
}

export const IcmTabbedPieChart = memo(
  ({ tabs, className }: IcmTabbedPieChartProps) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const activeData = tabs[activeIndex]?.data ?? [];

    if (tabs.every((t) => t.data.length === 0)) return null;

    return (
      <Stack gap="sm" className={cn("w-full min-w-0 max-w-[500px]", className)}>
        {tabs.length > 1 && (
          <Stack direction="row" justify="end" align="center" gap="md">
            {tabs.map(({ label }, i) => (
              <button
                key={label}
                type="button"
                onClick={() => setActiveIndex(i)}
              >
                <Typography
                  variant="captionW1"
                  className={cn(
                    i === activeIndex
                      ? "font-semibold text-foreground"
                      : "text-muted-foreground hover:text-foreground",
                  )}
                >
                  {label}
                </Typography>
              </button>
            ))}
          </Stack>
        )}
        <IcmPieChart data={activeData} />
      </Stack>
    );
  },
);
